import {
  INICIALITZAR,
  INDIVIDU_INICIALITZAR,
  INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS,
  OBTENIR_DADES_CREACIO_INDIVIDU,
  ESBORRAR_INDIVIDU_SELECCIONAT
} from "../../../actions/actionTypes";

export const INDIVIDU_FORMULARI_INDRETS_ESTAT_INICIAL = [];

const indrets = (state = INDIVIDU_FORMULARI_INDRETS_ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR || INICIALITZAR:
    case INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS:
    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_EN_CURS`:
    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_ERROR`:
    case ESBORRAR_INDIVIDU_SELECCIONAT:
      return INDIVIDU_FORMULARI_INDRETS_ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`: {
      return action.payload.indrets;
    }

    default:
      return state;
  }
};

export default indrets;
